import Fuse from "fuse.js";

const MAX_RESULTSET_LENGTH = 100;

const normalize = (s = "") =>
  String(s)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

const filterItems = (items, filter) => {
  const q = normalize(filter);
  if (!q) return items.slice(0, MAX_RESULTSET_LENGTH);

  const fuse = new Fuse(items, {
    isCaseSensitive: false,
    shouldSort: true,
    threshold: 0.35,
    distance: 120,
    ignoreLocation: true,
    minMatchCharLength: q.length,
    keys: ["label", "value"],

    getFn: (obj, path) => normalize(obj[path]),
  });

  return fuse
    .search(q)
    .slice(0, MAX_RESULTSET_LENGTH)
    .map((r) => r.item);
};

export default filterItems;
